import $ from "jquery";

/**
 * Spawns a shiney star and animates it from `pageElement` to `.document-viewer-toc`
 */
export function spawnAnimation(pageElement) {
  var top = pageElement.offset().top,
      left = pageElement.offset().left;

  // create star
  var element = $("<div class='favorite-animation' />");

  // set initial position
  element.offset({
    left: left,
    top: top
  });

  element.css({ opacity: 0.0 });

  window.setTimeout(function() { element.css({ opacity: 1.0 }) }, 100);
  window.setTimeout(function() { element.css({ opacity: 0.0 }) }, 900);

  window.setTimeout(
    function() {
      element.remove();
      element = null;
    },
    1000
  );


  // append to body
  $(body).append(element);

  var target = $(".document-viewer-toc-sections--root");

  element.offset({
    left: target.offset().left + 15,
    top: target.offset().top + 15
  });
}



// WEBPACK FOOTER //
// ./app/javascript/portal/documents/favorite_animation.js